import { useFinanceIqEnabled } from '@/enterprise/data/useFinanceIqEnabled';
import { useFeatureForUser } from '@/lib/features';
import QueryBoundaries from '@/shared/components/QueryBoundaries';
import Skeleton from '../../components/Skeleton';
import FinanceIQWidgetContent from './FinanceIQWidgetContent';

const FinanceIQWidgetSkeleton = () => <Skeleton height="h-[500px]" />;

const FinanceIQWidget = () => {
  const isEnabled = useFinanceIqEnabled();
  // Global kill switch — flip off to hide the widget for everyone.
  const [isHomepageWidgetEnabled] = useFeatureForUser('enterprise-ui_enableFinanceIQHomepageWidget');

  if (!isEnabled || !isHomepageWidgetEnabled) {
    return null;
  }

  return (
    <div className="pt-12">
      <QueryBoundaries LoadingComponent={FinanceIQWidgetSkeleton}>
        <FinanceIQWidgetContent />
      </QueryBoundaries>
    </div>
  );
};

export default FinanceIQWidget;
